module.exports = __webpack_public_path__ + "img/168.b4ad5403.jpg";